import * as types from '../constants/actionTypes';
import LoopbackHttp from '../businessLogic/LoopbackHttp.js';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

export function createOrder(fields) {
  return (dispatch) => {
    LoopbackHttp.createOrder(fields)
      .then((data) => {
        dispatch({
          type: types.ORDER_CREATED,
          orderCreated: Date.now(),
          createdStuff: data
        });
      })
      .catch((data) => {
        dispatch({
          type: types.ORDER_CREATION_FAILED,
          error: data
        });
      });
  };
}

export function createOrderByOperator(fields) {
  return (dispatch) => {
    LoopbackHttp.createOrderByOperator(fields)
      .then((data) => {
        dispatch({
          type: types.ORDER_CREATED,
          orderCreated: Date.now(),
          createdStuff: data
        });
      })
      .catch(() => {
        dispatch({
          type: types.ORDER_CREATION_FAILED
        });
      });
  };
}

export function getTeamsForFleetOrderCreation(id) {
  return (dispatch) => {
    //dispatch(showLoading());
    LoopbackHttp.getTeamsForFleetOrderCreation(id)
      .then((data) => {
        dispatch({
          type: types.TEAMS_FOR_ORDERCREATION_FETCHED,
          teams: data
        });
        dispatch(hideLoading());
      })
      .catch(() => {

        dispatch(hideLoading());
      });
  };
}

export function getTeamsForOperatorOrderCreation(id) {
  return (dispatch) => {
    //dispatch(showLoading());
    LoopbackHttp.getTeamsForOperatorOrderCreation(id)
      .then((data) => {
        dispatch({
          type: types.TEAMS_FOR_ORDERCREATION_FETCHED,
          teams: data
        });
        dispatch(hideLoading());
      })
      .catch(() => {

        dispatch(hideLoading());
      });
  };
}

export function getTeamsPoints(teams) {
  return (dispatch) => {
    //dispatch(showLoading());
    LoopbackHttp.getTeamsPoints(teams)
      .then((data) => {
        dispatch({
          type: types.POINTS_FETCHED,
          pickUpPoints: data
        });
        dispatch(hideLoading());
      })
      .catch(() => {

        dispatch(hideLoading());
      });
  };
}

export function getDispatcherPoints(id) {
  return (dispatch) => {
    LoopbackHttp.getDispatcherPoints(id)
      .then((data) => {
        dispatch({
          type: types.POINTS_FETCHED,
          pickUpPoints: data
        });
      })
      .catch(() => {

      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/createOrderActions.js